import React from "react";
import "../styles/Footer.css";
import { FaWhatsapp, FaInstagram, FaFacebook, FaTiktok } from "react-icons/fa";

const NAV_LINKS = [
  { href: "#home",     label: "Home" },
  { href: "#about",    label: "About" },
  { href: "#services", label: "Services" },
  { href: "#packages", label: "Packages" },
  { href: "#contact",  label: "Contact" },
];

const SERVICES_LINKS = [
  "Web Development",
  "Mobile App Development",
  "SaaS Development",
  "AI Integration & Automation",
  "Custom Systems",
  "SEO Optimization",
  "Hosting & Support",
];

const SOCIALS = [
  { Icon: FaWhatsapp,  label: "WhatsApp", href: "https://wa.me/96181233235" },
  { Icon: FaInstagram, label: "Instagram", href: "https://instagram.com/codix.lb" },
  { Icon: FaFacebook,  label: "Facebook",  href: "https://www.facebook.com/share/17fNY6Dqdk" },
  { Icon: FaTiktok,    label: "TikTok",    href: "https://www.tiktok.com/@codix.lb" },
];

function Footer() {
  return (
    <footer className="footer">
      {/* top accent line */}
      <div className="footer-top-line" aria-hidden="true" />

      <div className="footer-inner">

        {/* ── Brand column ── */}
        <div className="footer-brand">
          <a href="#home" className="footer-logo" aria-label="Codix Tech home">
            <span className="footer-logo-bracket">&lt;</span>
            <span className="footer-logo-c">C</span>
            <span className="footer-logo-odix">odix</span>
            <span className="footer-logo-slash">/</span>
            <span className="footer-logo-bracket">&gt;</span>
          </a>

          <p className="footer-brand-desc">
            We design and develop modern, high-performance digital products —
            from business websites to full-stack SaaS platforms, mobile apps,
            and AI-powered systems. Every line of code is built for growth.
          </p>

          <div className="footer-socials">
            {SOCIALS.map(({ Icon, label, href }) => (
              <a
                key={label}
                href={href}
                target="_blank"
                rel="noreferrer"
                aria-label={`Codix Tech ${label}`}
                className="footer-social-icon"
              >
                <Icon />
              </a>
            ))}
          </div>
        </div>

        {/* ── Quick Links ── */}
        <div className="footer-col">
          <h4 className="footer-col-title">
            <span className="footer-col-mono">// </span>Navigation
          </h4>
          <ul className="footer-links">
            {NAV_LINKS.map(({ href, label }) => (
              <li key={label}>
                <a href={href} aria-label={`Codix Tech ${label}`}>
                  <span className="footer-link-dot" aria-hidden="true" />
                  {label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        {/* ── Services ── */}
        <div className="footer-col">
          <h4 className="footer-col-title">
            <span className="footer-col-mono">// </span>Services
          </h4>
          <ul className="footer-links">
            {SERVICES_LINKS.map((s) => (
              <li key={s}>
                <a href="#services" aria-label={s}>
                  <span className="footer-link-dot" aria-hidden="true" />
                  {s}
                </a>
              </li>
            ))}
          </ul>
        </div>

        {/* ── Contact ── */}
        <div className="footer-col">
          <h4 className="footer-col-title">
            <span className="footer-col-mono">// </span>Contact
          </h4>

          <div className="footer-contact-items">
            <a href="mailto:info@codixlb.com" className="footer-contact-item">
              <span className="footer-contact-label">Email</span>
              <span className="footer-contact-value">info@codixlb.com</span>
            </a>
            <a href="tel:+96181233235" className="footer-contact-item">
              <span className="footer-contact-label">Phone</span>
              <span className="footer-contact-value">+961 81 233 235</span>
            </a>
            <a
              href="https://book.codixlb.com"
              target="_blank"
              rel="noreferrer"
              className="footer-contact-item"
            >
              <span className="footer-contact-label">Book a Call</span>
              <span className="footer-contact-value">book.codixlb.com</span>
            </a>
          </div>

          <a
            href="https://book.codixlb.com"
            target="_blank"
            rel="noreferrer"
            className="footer-cta"
          >
            Start a Project →
          </a>
        </div>

      </div>

      {/* ── Bottom bar ── */}
      <div className="footer-bottom">
        <div className="footer-bottom-inner">
          <p className="footer-copy">
            © {new Date().getFullYear()} Codix Tech. All rights reserved.
          </p>

          <p className="footer-made">
            Built with{" "}
            <span className="footer-orange" aria-label="love">♥</span>
            {" "}by Codix Tech — Lebanon
          </p>

          <div className="footer-legal">
            <a href="/privacy-policy.html">Privacy Policy</a>
            <span aria-hidden="true">·</span>
            <a href="/terms-of-service.html">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
